import { logoLinksSearchStyles } from "@insite/content-library/Widgets/Header/LogoLinksSearch";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";


logoLinksSearchStyles.container = {
    css: css`
        display: flex;
        justify-content: space-between;
        margin: 0 auto;
        max-width: 1440px;
        padding: 0 20px;
    `,
}

logoLinksSearchStyles.logoWrapper = {
    css: css`
        text-align: left;
        padding: 20px 45px 20px 0;
        margin: 0 24px 0 0;
        ${({ theme }) => {
            return breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        flex-grow: 1;
                    `,
                    null,
                    null,
                ],
                "max",
            );
        }}
        img {
            height: 78px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            height: 42px;
                            width: auto;
                            margin: 0;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        }
    `,
}

logoLinksSearchStyles.searchMenuWrapper = {
    css: css`
        text-align: right;
        padding: 20px 0 20px 45px;
        ${({ theme }) => {
            return breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        display: none;
                    `,
                    css`
                        flex-grow: 8;
                    `,
                    null,
                    null,
                ],
                "max",
            );
        }}
    `,
}